import { SentryErrorBoundary } from "@/lib/sentry";
import { AlertCircle } from "lucide-react";
import { Button } from "./ui/button";

export function GlobalErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SentryErrorBoundary
      fallback={({ error }) => (
        <div className="flex h-screen items-center justify-center p-4">
          <div className="max-w-md text-center">
            <AlertCircle className="mx-auto h-12 w-12 mb-4" />
            <h1 className="text-2xl font-bold mb-2">Something went wrong</h1>
            <p className="text-muted-foreground mb-4">
              An unexpected error occurred.
              <br />
              We've been notified and will look into it.
            </p>
            {import.meta.env.MODE === "development" && (
              <pre className="text-left text-sm bg-gray-100 p-4 rounded mb-4 overflow-auto">
                [dev]
                <br />
                {error?.toString()}
              </pre>
            )}
            <div className="space-x-4">
              <Button
                variant="outline"
                onClick={() => (window.location.href = "/")}
              >
                Go to Home
              </Button>
            </div>
          </div>
        </div>
      )}
      showDialog={false}
    >
      {children}
    </SentryErrorBoundary>
  );
}
